import React from 'react';
import ErrorRecordProgressiveList from './ErrorRecordProgressiveList';
import { ERROR_RECORD_LIST_MASKS } from '../../utils/errorRecordListMasks';

export default function ZoznamExt(props) {
  return <ErrorRecordProgressiveList mask={ERROR_RECORD_LIST_MASKS.ext} {...props} />;
}
